import { createContext, useContext, type ReactNode } from "react";
import { accountApi } from "@/resources/account";
import { ACCOUNT_ROLE } from "@/constants";

const ViewerReadOnlyContext = createContext(false);

export function ViewerReadOnlyProvider({ children }: { children: ReactNode }) {
  const { data: account } = accountApi.useGetAccount();
  const readOnly = account?.role === ACCOUNT_ROLE.VIEWER;
  return (
    <ViewerReadOnlyContext.Provider value={readOnly}>
      {children}
    </ViewerReadOnlyContext.Provider>
  );
}

export function useViewerReadOnly(): boolean {
  return useContext(ViewerReadOnlyContext);
}
